import { MouseEvent } from 'react';
import { SearchItemWithImageViewModel } from '@/types/api';
import { getSearchResultItemURL } from '@/features/navigation/utils/url-helpers';
import { NavigationCarousel } from '@/features/carousel';
import { IconFire } from '@/features/icons';
import { EasyAccess } from '@/features/tag';
import { cn } from '@/utils/cn';
interface Props {
  title: string;
  items: SearchItemWithImageViewModel[] | null;
  handleClickItem: (e: MouseEvent, href: string) => void;
}
const Suggestions = ({
  title,
  items,
  handleClickItem
}: Props) => {
  if (!items?.length) return;
  return <div className='flex w-full flex-col gap-3 text-text-black lg:mt-0 lg:px-1' data-sentry-component="Suggestions" data-sentry-source-file="suggestions.tsx">
            <div className='flex flex-row items-center'>
                <IconFire className='h-5 w-5' data-sentry-element="IconFire" data-sentry-source-file="suggestions.tsx" />
                <span className='pr-2 text-sm font-medium'>{title}</span>
            </div>

            <div className='flex flex-col items-start gap-4 overflow-auto lg:overflow-hidden lg:pl-0' data-test='search-result--popular'>
                <NavigationCarousel className='flex' options={{
        perView: 'auto',
        spacing: 4,
        mode: 'free'
      }} data-sentry-element="NavigationCarousel" data-sentry-source-file="suggestions.tsx">
                    {items.map(item => {
          const itemHref = getSearchResultItemURL(item);
          return <div key={item.id} className={cn('keen-slider__slide max-w-fit', !item?.imageUrl && 'w-full min-w-fit overflow-visible whitespace-nowrap')}>
                                <EasyAccess size='medium' href={itemHref} className='border-border-gray-light bg-white' onClick={e => handleClickItem(e, itemHref)} marketing={{
              itemID: item.id ?? '',
              term: item.nameFa ?? '',
              elementType: 'Search-MostPopularTerms',
              elementName: 'Search-MostPopularTerms',
              elementIndex: (item?.position ?? 0) + 1
            }}>
                                    {item.nameFa}
                                </EasyAccess>
                            </div>;
        })}
                </NavigationCarousel>
            </div>
        </div>;
};
export default Suggestions;